import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    body1: {
      fontFamily: 'inherit !important',
    },
    h6: {
      fontFamily: 'inherit',
    },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: 'inherit',
        },
        wrapper: {
          fontFamily: 'inherit',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'inherit',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'inherit',
        },
      },
    },
  },
});

// const theme = createTheme(adaptV4Theme({
//   typography: {
//     body1: {
//         fontFamily:'inherit !important'
//     },
//     h6:{
//         fontFamily:'inherit'
//     }
//   },
//   Tab:{
//     root:{
//       fontFamily:'inherit'
//     },
//     wrapper:{
//       fontFamily: 'inherit'
//     }
//   },
//   FormLabel:{
//     root:{
//       fontFamily:'inherit'
//     }
//   },
//   InputBase:{
//     root:{
//       fontFamily:'inherit'
//     }
//   }
// }))

// const title = createTheme(adaptV4Theme({
//   typography:{
//     h6:{
//       fontFamily:'inherit',
//       fontSize:'1rem'
//     }
//   }
// }));

// const title = createTheme(adaptV4Theme({
//   typography:{
//     h6:{
//       fontFamily:'inherit',
//       fontSize:'1rem'
//     }
//   }
// }));

const title = createTheme({
  typography: {
    h6: {
      fontFamily: 'inherit',
      fontSize: '1rem',
    },
  },
});

// theme for '../components/parent/ChildDialog.js'
// const childDialogTheme = createTheme(adaptV4Theme({
//   typography:{
//     h6:{
//       fontFamily:'inherit',
//       textTransform: 'capitalize',
//       fontWeight: 'bold',
//       color: '#fff',
//       [breakpoints.between('xs','sm')]: {
//         fontSize:'1rem'
//       }
//     }
//   }
// }));

const childDialogTheme = createTheme({
  typography: {
    h6: {
      fontFamily: 'inherit',
      textTransform: 'capitalize',
      fontWeight: 'bold',
      color: '#fff',
      [theme.breakpoints.between('xs','sm')]: {
        fontSize: '1rem', // Adjust for xs to sm breakpoints
      },
    },
  },
});

// const loginDialogTheme = createTheme(adaptV4Theme({
//   typography:{
//     h6:{
//       fontFamily:'inherit',
//       textTransform: 'capitalize',
//       fontWeight: 'bold',
//       color: '#fff',
//       display:'flex',
//       flexDirection:'row',
//       alignItems:'center',
//       justifyContent:'space-between',
//       width:'100%',
//       [breakpoints.between('xs','sm')]: {
//         fontSize:'1rem'
//       }
//     }
//   }
// }));

const loginDialogTheme = createTheme({
  typography: {
    h6: {
      fontFamily: 'inherit',
      textTransform: 'capitalize',
      fontWeight: 'bold',
      color: '#fff',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      // fontSize: '1.25rem', // Default font size
      // Using breakpoints for responsive font size
      // Define the theme in your component to use breakpoints
      [theme.breakpoints.between('xs', 'sm')]: {
        fontSize: '1rem',
      },
    },
  },
});

// CUSTOM STEPPER FOR SCHOOL ADMISSION PAGE
// const SchoolAdmissionStepper = createTheme(adaptV4Theme({
//   MuiStepIcon: {
//     root: {
//       '&$active': {
//         color: '#67108F',
//       },
//       '&$completed': {
//         color: '#0AB8E5',
//       },
//     },
//   },
// }));

const SchoolAdmissionStepper = createTheme({
  components: {
    MuiStepIcon: {
      styleOverrides: {
        root: {
          '&.Mui-active': { // Use the class directly for active state
            color: '#67108F',
          },
          '&.Mui-completed': { // Use the class directly for completed state
            color: '#0AB8E5',
          },
        },
      },
    },
  },
});


export { title, childDialogTheme, SchoolAdmissionStepper, loginDialogTheme };

export default theme;